module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box",
    class: 'activeTab_' + _vm.activeTab
  }, [_c('tabs', {
    attrs: {
      "type": "boxed"
    },
    on: {
      "tab-selected": _vm.tabSelected
    }
  }, [_c('tab-pane', {
    attrs: {
      "label": _vm.$t('campaigns.campaignParams.campaignsParameters')
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.title')))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.namePostfix),
      expression: "campaign.namePostfix"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('campaigns.putCampaignsName'),
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.namePostfix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "namePostfix", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.callDate')))]), _vm._v(" "), _c('datepicker', {
    staticClass: "date",
    attrs: {
      "disabled": !_vm.canEdit() && !_vm.canContinue(),
      "placeholder": _vm.$t('campaigns.campaignParams.putCallDate'),
      "config": {
        wrap: true,
        dateFormat: 'd.m.Y',
        locale: _vm.l10n
      }
    },
    model: {
      value: (_vm.campaign.date),
      callback: function($$v) {
        _vm.$set(_vm.campaign, "date", $$v)
      },
      expression: "campaign.date"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "data-toggle": "",
      "disabled": !_vm.canEdit() && !_vm.canContinue()
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "data-clear": "",
      "disabled": !_vm.canEdit() && !_vm.canContinue()
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.timezone')) + " (UTC)")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.zoneOffset),
      expression: "campaign.zoneOffset"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "zoneOffset", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("+1")]), _vm._v(" "), _c('option', [_vm._v("+2")]), _vm._v(" "), _c('option', [_vm._v("+3")]), _vm._v(" "), _c('option', [_vm._v("+4")]), _vm._v(" "), _c('option', [_vm._v("+5")]), _vm._v(" "), _c('option', [_vm._v("+6")]), _vm._v(" "), _c('option', [_vm._v("+7")]), _vm._v(" "), _c('option', [_vm._v("+8")]), _vm._v(" "), _c('option', [_vm._v("+9")]), _vm._v(" "), _c('option', [_vm._v("+10")]), _vm._v(" "), _c('option', [_vm._v("+11")]), _vm._v(" "), _c('option', [_vm._v("+12")])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.callTime')))]), _vm._v(" "), _c('p', {
    staticClass: "control has-addons"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.timeInterval.from'))), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.timeStart),
      expression: "campaign.timeStart"
    }],
    staticClass: "time",
    attrs: {
      "type": "text",
      "pattern": "(([0,1][0-9])|(2[0-3])):[0-5][0-9]",
      "placeholder": "XX:XX",
      "value": "10:00",
      "readonly": !_vm.canEdit() && !_vm.canContinue(),
      "onblur": _vm.transformTimeStart()
    },
    domProps: {
      "value": (_vm.campaign.timeStart)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "timeStart", $event.target.value)
      }
    }
  }), _vm._v("\n              " + _vm._s(_vm.$t('common.timeInterval.to'))), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.timeEnd),
      expression: "campaign.timeEnd"
    }],
    staticClass: "time",
    attrs: {
      "type": "text",
      "pattern": "(([0,1][0-9])|(2[0-3])):[0-5][0-9]",
      "placeholder": "XX:XX",
      "value": "18:00",
      "readonly": !_vm.canEdit() && !_vm.canContinue(),
      "onblur": _vm.transformTimeEnd()
    },
    domProps: {
      "value": (_vm.campaign.timeEnd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "timeEnd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.numberOfAttemptsToGetThrough')))]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingAttempts),
      expression: "campaign.postponingAttempts"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "postponingAttempts", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("0")]), _vm._v(" "), _c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.intervalBetweenRepeatedCalls')) + " (" + _vm._s(_vm.$t('common.time.minutes')) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingIntervalMin),
      expression: "campaign.postponingIntervalMin"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "postponingIntervalMin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("30")]), _vm._v(" "), _c('option', [_vm._v("60")]), _vm._v(" "), _c('option', [_vm._v("120")]), _vm._v(" "), _c('option', [_vm._v("240")])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('scenarios.scenario')))]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.scenario),
      expression: "campaign.scenario"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.getScenarioReadyState,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "scenario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.scenarios), function(scenario) {
    return _c('option', {
      domProps: {
        "value": scenario.id
      }
    }, [_vm._v("\n                " + _vm._s(scenario.name) + "\n              ")])
  }), 0)]), _vm._v(" "), (_vm.campaign.scenario) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.gotoScenario
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.openScenario')))])]) : _vm._e(), _vm._v(" "), (_vm.isReadyScenario) ? _c('button', {
    staticClass: "button is-success is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.scenarioIsReady')))])]) : _c('button', {
    staticClass: "button is-danger is-outlined",
    attrs: {
      "disabled": true
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.scenarioIsNotReady')))])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.base')))]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit(),
      "type": "button",
      "id": "uploadFile",
      "value": _vm.$t('common.actions.loadFromFile')
    },
    on: {
      "click": function($event) {
        return _vm.uploadFile('uploadPhones')
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "uploadPhones",
      "name": "load-phones",
      "type": "file",
      "accept": ".txt,.csv,.xls,.xlsx"
    },
    on: {
      "input": function($event) {
        return _vm.uploadPhones('uploadPhones')
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.openModalClipboard
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.putBaseFromClipboard')))])]), _vm._v(" "), (_vm.tasksCount > 0) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewCallTasks
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.viewBase')))])]) : _vm._e(), _vm._v(" "), (_vm.tasksCountPerformed == 0 && _vm.tasksCount > 0 && !_vm.campaign.archiveStatus) ? _c('button', {
    staticClass: "button is-light delete-button",
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.openModalDelete
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.removeBase')))])]) : _vm._e(), _vm._v(" "), (_vm.canContinue()) ? _c('button', {
    staticClass: "button is-warning",
    on: {
      "click": _vm.getReadyCallTasksCSV
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-info"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.unprocessed')) + " " + _vm._s(_vm.$t('campaigns.campaignParams.numbers')))])]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.uploadedNumbers')) + ": " + _vm._s(_vm.tasksCount))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('testCall.testCall')))]), _vm._v(" "), _c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": _vm.campaign.archiveStatus
    },
    on: {
      "click": function($event) {
        return _vm.callTest(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-volume-control-phone"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('testCall.callToNumber')))])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.testPhone),
      expression: "testPhone"
    }],
    staticClass: "input",
    attrs: {
      "disabled": _vm.campaign.archiveStatus,
      "type": "text",
      "placeholder": _vm.$t('testCall.putNumber')
    },
    domProps: {
      "value": (_vm.testPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewTestCallTasks
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('testCall.viewTestResults')))])])])]), _vm._v(" "), (!_vm.campaign.archiveStatus) ? _c('div', {
    staticClass: "control"
  }, [_c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    attrs: {
      "title": _vm.$t('testCall.testCallParameters')
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.key')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.testPhoneParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTestPhoneParameter(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.delete')))])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addTestPhoneParameter
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.add')))])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('br')], 1), _vm._v(" "), (_vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('tab-pane', {
    attrs: {
      "label": _vm.$t('campaigns.additionalParameters.additionalParameters')
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("FS Gateway")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.gateway),
      expression: "campaign.gateway"
    }],
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.campaign, "gateway", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.fsGateways), function(fsGateway) {
    return _c('option', {
      domProps: {
        "value": fsGateway.name
      }
    }, [_vm._v("\n                " + _vm._s(fsGateway.name) + "\n              ")])
  }), 0)])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Приоритет")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.priority),
      expression: "campaign.priority"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Приоритет рассылки",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.priority)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "priority", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Record Host")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.recordHost),
      expression: "campaign.recordHost"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.recordHost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "recordHost", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Postponing Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.postponingStrategy),
      expression: "campaign.postponingStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.postponingStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "postponingStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Schedule Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.scheduleStrategy),
      expression: "campaign.scheduleStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.scheduleStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "scheduleStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Tel Error Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.telErrorStrategy),
      expression: "campaign.telErrorStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.telErrorStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "telErrorStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Dialplan Context")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.dialplanContext),
      expression: "campaign.dialplanContext"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.dialplanContext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "dialplanContext", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Dialplan Extension")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.dialplanExtension),
      expression: "campaign.dialplanExtension"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.dialplanExtension)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "dialplanExtension", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Target Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.targetStrategy),
      expression: "campaign.targetStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.targetStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "targetStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Phone Preprocessing Strategy")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.campaign.phonePreprocessingStrategy),
      expression: "campaign.phonePreprocessingStrategy"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.canEdit()
    },
    domProps: {
      "value": (_vm.campaign.phonePreprocessingStrategy)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.campaign, "phonePreprocessingStrategy", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.key')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.phonePreprocessingParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text",
        "readonly": !_vm.canEdit()
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": !_vm.canEdit()
      },
      on: {
        "click": function($event) {
          return _vm.deletePhonePreprocessingParameter(index)
        }
      }
    }, [_c('span', {
      staticClass: "icon"
    }, [_c('i', {
      staticClass: "fa fa-minus-circle"
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.delete')))])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.canEdit()
    },
    on: {
      "click": _vm.addPhonePreprocessingParameter
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.add')))])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.quotaServiceAvailable && _vm.campaign && _vm.campaign.id) ? _c('tab-pane', {
    attrs: {
      "label": _vm.$t('campaigns.quotas.quotas')
    }
  }, [_c('div', {
    staticClass: "quotasShell"
  }, [_c('CampaignQuota', {
    attrs: {
      "campaign-id": _vm.campaign.id
    },
    on: {
      "serviceNotAvailable": _vm.quotaServiceNotAvailable
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "control toolButtons"
  }, [(_vm.canEdit() || _vm.canContinue()) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.save(true)
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.save')))])]) : _vm._e(), _vm._v(" "), (_vm.canSetReadyStatus() && !_vm.campaign.archiveStatus) ? _c('button', {
    staticClass: "button is-info",
    attrs: {
      "disabled": !_vm.canEdit(),
      "disabled": _vm.appconfig.disableCampaignSetReadyState
    },
    on: {
      "click": _vm.openModalReady
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.run')))])]) : _vm._e(), _vm._v(" "), (_vm.canPauseStatus()) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.openModalStop
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.stop')))])]) : _vm._e()]), _c('div', {
    staticClass: "report"
  }, [_c('ReportGenerator', {
    attrs: {
      "campaign-id": _vm.id,
      "check-status-when-created": true
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.downloadTestReport
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.reportByTestCalls')))])])])], 1), _vm._v(" "), (_vm.canLoadReport(_vm.campaign)) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewCallsResult
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.callResult')))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.close')))])]), _vm._v(" "), (!_vm.campaign.archiveStatus && _vm.canAccessAdditionalParameters(_vm.permissionKey)) ? _c('button', {
    staticClass: "button is-info",
    on: {
      "click": _vm.viewMonitor
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('campaigns.campaignParams.callsMonitoring')))])]) : _vm._e(), _vm._v(" "), _c('p')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "visible": _vm.showModal,
      "title": _vm.title,
      "confirmation": _vm.confirmation,
      "clipboard": !_vm.confirmation
    },
    on: {
      "confirm": _vm.confirmAction,
      "close": _vm.closeModal
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-stop-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-tv"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8757686c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/campaigns/Campaign.vue
// module id = 454
// module chunks = 42